(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  class BrewFilterForm extends HTMLElement {
    constructor() {
      super();
      this.instance = this.dataset.instance;
      this.form = this.querySelector('form');
      this.form.addEventListener('change', this.onSubmit.bind(this));
      this.form.addEventListener('click', (e) => {
        const removeLink = e.target.closest('.js-facet-remove');
        if (removeLink) {
          e.preventDefault();
          this.onRemove(removeLink.href);
        }
      });
    }

    onSubmit(event) {
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams(formData).toString();
      this.fetchAndRender(searchParams);
    }

    onRemove(href) {
      const searchParams = href.includes('?') ? href.slice(href.indexOf('?') + 1) : '';
      this.fetchAndRender(searchParams);
    }

    fetchAndRender(searchParams) {
      const gridContainer = document.getElementById(`ProductGridContainer-${this.instance}`);
      if (!gridContainer) return;

      const sectionId = gridContainer.dataset.id;
      if (!sectionId) return;

      gridContainer.classList.add('loading');
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;

      fetch(url)
        .then((res) => res.text())
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');

          const newGrid = parsed.getElementById(`ProductGridContainer-${this.instance}`);
          if (newGrid) gridContainer.innerHTML = newGrid.innerHTML;
          gridContainer.classList.remove('loading');

          const newForm = parsed.getElementById(`FacetFiltersForm-${this.instance}`);
          if (newForm) this.form.innerHTML = newForm.innerHTML;

          const buttonWrap = document.querySelector(
            `.infinite__scroll--button-wrap[data-instance="${this.instance}"]`,
          );
          if (buttonWrap) {
            const newButtonWrap = parsed.querySelector(
              `.infinite__scroll--button-wrap[data-instance="${this.instance}"]`,
            );
            if (newButtonWrap) buttonWrap.outerHTML = newButtonWrap.outerHTML;
          }

          if (typeof initInfiniteScroll === 'function') {
            initInfiniteScroll(this.instance);
          } else if (typeof infiniteScroll === 'function') {
            infiniteScroll();
          }

          window.history.pushState({}, '', url.includes('?') ? `${window.location.pathname}?${searchParams}` : window.location.pathname);
        });
    }
  }

  customElements.define('brew-filter-form', BrewFilterForm);

  } catch(e) { console.error(e); }
})();
})();
